export enum COMPANY_TYPE {
    
    BUYER = 3,

    VENDOR = 4,

    COMMISSIONARY = 5
}